<template>
  <div class="account-file-row row-eq-height row billing-item" :class="{ 'hover': index % 2 == 0 }">
    <div class="rt-cell col-xs-2">
      <div class="text-center">
        <span class="fa-2x" :class="[
          carFeature.icon,
          {
            'fab': carFeature.icon === 'fa-bluetooth',
            'fa': carFeature.icon !== 'fa-bluetooth'
          }
        ]"></span>
      </div>
    </div>
    <div class="rt-cell col-xs-5">
      {{ carFeature.name }}
    </div>
    <div class="rt-cell col-xs-3">
      <div class="text-center">
        {{ carFeature.Cars.length }}
      </div>
    </div>
    <div class="rt-cell last-rt-cell col-xs-2">
      <router-link class="btn btn-default" :to="'/fleet/vehicles/features/edit/' + carFeature.uuid">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarFeatureRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    carFeature () {
      return {
        Cars: [],
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/CarFeature.vue